import { useRouteError } from "react-router-dom";
import { Button } from "./components/ui/button";
const ErrorBoundary = () => {






    const reset = () => {
        localStorage.removeItem('persist:root');
        window.location.reload();
    }


    const error: any = useRouteError();


    return (
        <section className="m-10 h-[100vh]">
            <h1>Something went wrong...</h1>
            <Button onClick={() => reset()}>Try again</Button>
            <div><small>{error?.message}</small></div>
            <div><small>{error?.data}</small></div>
            <small className="block">
                {error?.stack?.split('\n').map((line: string, index: number) => (
                    <div className={`${'mt-1 mb-2 block'}${line.includes('tsx') ? ' underline text-red-400 font-bold' : ''}`} key={index}>{line}</div>
                ))}
            </small >

        </section>
    );
};

export default ErrorBoundary;